/**
 * Gratisgeschenk ab Schwellenwert (docs/FREE-GIFT-140.md).
 *
 * A REAL cart system, not a visual bar:
 * - eligible subtotal = sum of item final_line_price EXCLUDING gift lines
 *   (Shopify cart JSON values only — no DOM parsing)
 * - eligible >= threshold  -> exactly ONE gift line is auto-added
 *   (properties._dylys_gift = "1", quantity locked to 1)
 * - eligible <  threshold  -> the gift line is removed again
 * - duplicate/increased gift lines are corrected back to quantity 1
 * - a manually purchased gift product (no _dylys_gift property) is a normal
 *   line: it counts toward eligibility and is never touched
 * - if the customer removes the gift by hand, we respect that for the session
 *   (sessionStorage) instead of re-adding in a loop
 * - the actual 0-€ price at checkout comes from the automatic Buy-X-Get-Y
 *   discount (see docs/FREE-GIFT-140.md) — the theme only guarantees the gift
 *   line exists; cart-lines.liquid renders the GRATISGESCHENK badge and the
 *   discounted line price
 *
 * Loop safety: one adjustment at a time (busy flag); after our own mutation we
 * re-evaluate once — adding the gift never changes the eligible subtotal, so
 * the state converges immediately.
 */
(function () {
  'use strict';

  var cfg = window.DylysGift || { enabled: false };
  var busy = false;
  var DISMISS_KEY = 'dylys-gift-dismissed';

  function formatMoney(cents) {
    var amount = (cents / 100).toLocaleString('de-DE', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
    return amount + ' €';
  }

  function isGiftLine(item) {
    return !!(item.properties && item.properties._dylys_gift) &&
      cfg.variantId && item.variant_id === cfg.variantId;
  }

  function eligibleSubtotal(cart) {
    return cart.items.reduce(function (sum, item) {
      return isGiftLine(item) ? sum : sum + item.final_line_price;
    }, 0);
  }

  function dismissed() {
    try { return sessionStorage.getItem(DISMISS_KEY) === '1'; } catch (e) { return false; }
  }

  // Detect a manual gift removal: previous cart had our gift line, new cart
  // doesn't, and the eligible subtotal still qualifies.
  var hadGift = null;

  function updateBars(cart) {
    var eligible = cart ? eligibleSubtotal(cart) : 0;
    document.querySelectorAll('[data-gift-progress]').forEach(function (box) {
      var threshold = parseInt(box.getAttribute('data-gift-threshold'), 10) || cfg.thresholdCents;
      if (!threshold) return;
      var missing = Math.max(0, threshold - eligible);
      var pct = Math.min(100, Math.round((eligible / threshold) * 100));
      var bar = box.querySelector('[data-gift-bar]');
      var text = box.querySelector('[data-gift-text]');
      if (bar) bar.style.width = pct + '%';
      if (text) {
        if (missing === 0 && cfg.enabled) {
          text.textContent = cfg.reachedText || '';
        } else {
          var template = box.getAttribute('data-gift-template') || '';
          text.textContent = template.replace('[[amount]]', formatMoney(missing));
        }
      }
    });
  }

  function mutate(url, payload) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (res) {
      return res.json().then(function (data) { return { ok: res.ok, data: data }; });
    });
  }

  function refreshAndAnnounce() {
    return fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        document.dispatchEvent(new CustomEvent('dylys:cart-change', {
          detail: { cart: cart, source: 'gift' }
        }));
      });
  }

  function reconcile(cart) {
    updateBars(cart);
    if (!cfg.enabled || !cfg.variantId || busy) return;

    var giftLines = cart.items
      .map(function (item, i) { return { item: item, line: i + 1 }; })
      .filter(function (x) { return isGiftLine(x.item); });
    var eligible = eligibleSubtotal(cart);
    var qualifies = eligible >= cfg.thresholdCents;

    // manual removal detection
    if (hadGift === true && giftLines.length === 0 && qualifies) {
      try { sessionStorage.setItem(DISMISS_KEY, '1'); } catch (e) { /* ignore */ }
    }
    hadGift = giftLines.length > 0;

    var action = null;
    if (qualifies && giftLines.length === 0 && !dismissed()) {
      action = mutate('/cart/add.js', {
        items: [{ id: cfg.variantId, quantity: 1, properties: { _dylys_gift: '1' } }]
      });
    } else if (!qualifies && giftLines.length > 0) {
      action = mutate('/cart/change.js', { line: giftLines[0].line, quantity: 0 });
    } else if (giftLines.length > 0 && giftLines[0].item.quantity !== 1) {
      action = mutate('/cart/change.js', { line: giftLines[0].line, quantity: 1 });
    } else if (giftLines.length > 1) {
      action = mutate('/cart/change.js', { line: giftLines[giftLines.length - 1].line, quantity: 0 });
    }
    if (!action) return;

    busy = true;
    action
      .then(function (result) {
        busy = false;
        if (result.ok) { hadGift = null; return refreshAndAnnounce(); }
      })
      .catch(function () { busy = false; });
  }

  document.addEventListener('dylys:cart-change', function (e) {
    if (e.detail && e.detail.cart) reconcile(e.detail.cart);
  });

  // initial state (page load / reload / back-forward cache)
  function boot() {
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(reconcile)
      .catch(function () { /* leave untouched */ });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  window.addEventListener('pageshow', function (e) { if (e.persisted) boot(); });
})();
